import { bearlog } from "@sillyscribe95/bear-ui-web";
import { chordDict, chorKeyDt, keyDict } from "../consts/keyConst";

export function onKeyMain(type, pitch = 0) {
  bearlog.lug("onKeyain-type---zz", type);
  let typenumb = keyDict[type] + pitch;
  return typenumb;
}

export function onChordMain(type, key, pitch = 0) {
  const keyBase =
    //
    type;
  // keyDict[type];

  const chordFunc = chordDict[type];

  bearlog.lug("onChordain-type---zz", { chordFunc, keyBase, type });

  let typo = chordFunc(keyBase);
  let newarra = typo.map((ansd) => ansd + pitch);

  return newarra;
}

export function onChordKey(type, pitch = 0) {
  let typo = chorKeyDt[type](keyDict[type]);
  let newarra = typo.map((ansd) => ansd + pitch);

  return newarra;
}

export function keyPlay(instrument, keys, ref) {
  let sijfe =
    //
    keys;
  //   [60, 64, 70];
  sijfe = Array.isArray(sijfe) ? sijfe : [sijfe];

  bearlog.lug("___ keyPlay ___", instrument, keys, ref);

  // reffo.

  // 1play 1time
  // midiSounds.player.queueWaveTable;
  ref.current.playChordNow(instrument, sijfe, 0.2);
}

export function playLong(instrument, keys, ref) {
  let asd = ref.current;
  let playos = asd.player;

  bearlog.lug("___ playos ___", asd);

  let insfjq = playos.loader.instrumentInfo(192).variable;

  bearlog.lug("___ insfjq ___", insfjq);

  let skfsa = asd.player.queueWaveTable(
    asd.audioContext,
    asd.equalizer.input,
    window[insfjq]
  );

  bearlog.lug("___ skfsa ___", skfsa);
  // setkeySound(skfsa);
}
